/**
 * Language-neutral, user-facing messages. The domain never produces finished sentences;
 * it emits a message key plus raw parameter values, and the UI renders them in the
 * user's language and number format.
 */

/** A percentage parameter (n is a fraction, e.g. 0.05 = 5 %), rendered with d decimals, with its sign if asked. */
interface PctParam {
  n: number;
  d: number;
  sign: boolean;
}

/** A date parameter (UTC ms, rendered as a calendar date). */
export interface DateParam {
  date: number;
}

export type MsgParam = string | number | PctParam | DateParam | Msg;

export interface Msg {
  k: string;
  p?: Record<string, MsgParam>;
}

export const msg = (k: string, p?: Record<string, MsgParam>): Msg => (p ? { k, p } : { k });

/** Percentage parameter (value is a fraction, e.g. 0.05 = 5%). */
export const pct = (value: number, d = 1, sign = false): PctParam => ({ n: value, d, sign });
export const day = (t: number): DateParam => ({ date: t });

export function isMsg(x: unknown): x is Msg {
  return typeof x === "object" && x !== null && typeof (x as Msg).k === "string";
}
